
/* custom file 3 */

document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('custom-store-redirect-popup');

    if (!popup) {
        console.warn('Store redirect popup not found in DOM.');
        return;
    }

    const closeButton = popup.querySelector('.store-redirect-close');
    const countryLabel = popup.querySelector('#store-redirect-country');

    if (!closeButton) {
        console.warn('Store redirect close button not found in DOM.');
        return;
    }

const redirectCountries = [
    // North America, Central America and the Caribbean
    'AI', 'AG', 'AW', 'BS', 'BB', 'BZ', 'BM', 'BQ',
    'VG', 'CA', 'KY', 'CR', 'CU', 'CW', 'DM', 'DO',
    'SV', 'GL', 'GD', 'GP', 'GT', 'HT', 'HN', 'JM',
    'MQ', 'MX', 'MS', 'NI', 'PA', 'PR', 'BL', 'KN',
    'LC', 'MF', 'PM', 'VC', 'SX', 'TT', 'TC', 'US',
    'VI',

    // South America
    'AR', 'BO', 'BR', 'CL', 'CO', 'EC', 'FK', 'GF',
    'GY', 'PY', 'PE', 'GS', 'SR', 'UY', 'VE',

    // // Asia
    // 'AF', 'AM', 'AZ', 'BH', 'BD', 'BT', 'BN', 'KH',
    // 'CN', 'CY', 'GE', 'HK', 'IN', 'ID', 'IR', 'IQ',
    // 'IL', 'JP', 'JO', 'KZ', 'KW', 'KG', 'LA', 'LB',
    // 'MO', 'MY', 'MV', 'MN', 'MM', 'NP', 'KP', 'OM',
    // 'PK', 'PS', 'PH', 'QA', 'SA', 'SG', 'KR', 'LK',
    // 'SY', 'TW', 'TJ', 'TH', 'TL', 'TR', 'TM', 'AE',
    // 'UZ', 'VN', 'YE',

    // Africa
    'DZ', 'AO', 'BJ', 'BW', 'BF', 'BI', 'CV', 'CM',
    'CF', 'TD', 'KM', 'CG', 'CD', 'CI', 'DJ', 'EG',
    'GQ', 'ER', 'SZ', 'ET', 'GA', 'GM', 'GH', 'GN',
    'GW', 'KE', 'LS', 'LR', 'LY', 'MG', 'MW', 'ML',
    'MR', 'MU', 'YT', 'MA', 'MZ', 'NA', 'NE', 'NG',
    'RE', 'RW', 'ST', 'SN', 'SC', 'SL', 'SO', 'ZA',
    'SS', 'SD', 'TZ', 'TG', 'TN', 'UG', 'EH', 'ZM',
    'ZW',

    // Oceania, Australia and the Pacific
    'AS', 'AU', 'CX', 'CC', 'CK', 'FJ', 'PF', 'GU',
    'KI', 'MH', 'FM', 'NR', 'NC', 'NZ', 'NU', 'NF',
    'MP', 'PW', 'PG', 'PN', 'WS', 'SB', 'TK', 'TO',
    'TV', 'UM', 'VU', 'WF',

    // Additional non-European territories
    'IO', 'TF', 'HM', 'SH'
];

const countryNames = {
    // North America, Central America and the Caribbean
    AI: { NAME: '🇦🇮 Anguilla' },
    AG: { NAME: '🇦🇬 Antigua and Barbuda' },
    AW: { NAME: '🇦🇼 Aruba' },
    BS: { NAME: '🇧🇸 The Bahamas' },
    BB: { NAME: '🇧🇧 Barbados' },
    BZ: { NAME: '🇧🇿 Belize' },
    BM: { NAME: '🇧🇲 Bermuda' },
    BQ: { NAME: '🇧🇶 Caribbean Netherlands' },
    VG: { NAME: '🇻🇬 British Virgin Islands' },
    CA: { NAME: '🇨🇦 Canada' },
    KY: { NAME: '🇰🇾 Cayman Islands' },
    CR: { NAME: '🇨🇷 Costa Rica' },
    CU: { NAME: '🇨🇺 Cuba' },
    CW: { NAME: '🇨🇼 Curaçao' },
    DM: { NAME: '🇩🇲 Dominica' },
    DO: { NAME: '🇩🇴 Dominican Republic' },
    SV: { NAME: '🇸🇻 El Salvador' },
    GL: { NAME: '🇬🇱 Greenland' },
    GD: { NAME: '🇬🇩 Grenada' },
    GP: { NAME: '🇬🇵 Guadeloupe' },
    GT: { NAME: '🇬🇹 Guatemala' },
    HT: { NAME: '🇭🇹 Haiti' },
    HN: { NAME: '🇭🇳 Honduras' },
    JM: { NAME: '🇯🇲 Jamaica' },
    MQ: { NAME: '🇲🇶 Martinique' },
    MX: { NAME: '🇲🇽 Mexico' },
    MS: { NAME: '🇲🇸 Montserrat' },
    NI: { NAME: '🇳🇮 Nicaragua' },
    PA: { NAME: '🇵🇦 Panama' },
    PR: { NAME: '🇵🇷 Puerto Rico' },
    BL: { NAME: '🇧🇱 Saint Barthélemy' },
    KN: { NAME: '🇰🇳 Saint Kitts and Nevis' },
    LC: { NAME: '🇱🇨 Saint Lucia' },
    MF: { NAME: '🇲🇫 Saint Martin' },
    PM: { NAME: '🇵🇲 Saint Pierre and Miquelon' },
    VC: { NAME: '🇻🇨 Saint Vincent and the Grenadines' },
    SX: { NAME: '🇸🇽 Sint Maarten' },
    TT: { NAME: '🇹🇹 Trinidad and Tobago' },
    TC: { NAME: '🇹🇨 Turks and Caicos Islands' },
    US: { NAME: '🇺🇸 United States' },
    VI: { NAME: '🇻🇮 U.S. Virgin Islands' },

    // South America
    AR: { NAME: '🇦🇷 Argentina' },
    BO: { NAME: '🇧🇴 Bolivia' },
    BR: { NAME: '🇧🇷 Brazil' },
    CL: { NAME: '🇨🇱 Chile' },
    CO: { NAME: '🇨🇴 Colombia' },
    EC: { NAME: '🇪🇨 Ecuador' },
    FK: { NAME: '🇫🇰 Falkland Islands' },
    GF: { NAME: '🇬🇫 French Guiana' },
    GY: { NAME: '🇬🇾 Guyana' },
    PY: { NAME: '🇵🇾 Paraguay' },
    PE: { NAME: '🇵🇪 Peru' },
    GS: { NAME: '🇬🇸 South Georgia and the South Sandwich Islands' },
    SR: { NAME: '🇸🇷 Suriname' },
    UY: { NAME: '🇺🇾 Uruguay' },
    VE: { NAME: '🇻🇪 Venezuela' },

    // Asia
    AF: { NAME: '🇦🇫 Afghanistan' },
    AM: { NAME: '🇦🇲 Armenia' },
    AZ: { NAME: '🇦🇿 Azerbaijan' },
    BH: { NAME: '🇧🇭 Bahrain' },
    BD: { NAME: '🇧🇩 Bangladesh' },
    BT: { NAME: '🇧🇹 Bhutan' },
    BN: { NAME: '🇧🇳 Brunei' },
    KH: { NAME: '🇰🇭 Cambodia' },
    CN: { NAME: '🇨🇳 China' },
    CY: { NAME: '🇨🇾 Cyprus' },
    GE: { NAME: '🇬🇪 Georgia' },
    HK: { NAME: '🇭🇰 Hong Kong' },
    IN: { NAME: '🇮🇳 India' },
    ID: { NAME: '🇮🇩 Indonesia' },
    IR: { NAME: '🇮🇷 Iran' },
    IQ: { NAME: '🇮🇶 Iraq' },
    IL: { NAME: '🇮🇱 Israel' },
    JP: { NAME: '🇯🇵 Japan' },
    JO: { NAME: '🇯🇴 Jordan' },
    KZ: { NAME: '🇰🇿 Kazakhstan' },
    KW: { NAME: '🇰🇼 Kuwait' },
    KG: { NAME: '🇰🇬 Kyrgyzstan' },
    LA: { NAME: '🇱🇦 Laos' },
    LB: { NAME: '🇱🇧 Lebanon' },
    MO: { NAME: '🇲🇴 Macao' },
    MY: { NAME: '🇲🇾 Malaysia' },
    MV: { NAME: '🇲🇻 Maldives' },
    MN: { NAME: '🇲🇳 Mongolia' },
    MM: { NAME: '🇲🇲 Myanmar' },
    NP: { NAME: '🇳🇵 Nepal' },
    KP: { NAME: '🇰🇵 North Korea' },
    OM: { NAME: '🇴🇲 Oman' },
    PK: { NAME: '🇵🇰 Pakistan' },
    PS: { NAME: '🇵🇸 Palestine' },
    PH: { NAME: '🇵🇭 Philippines' },
    QA: { NAME: '🇶🇦 Qatar' },
    SA: { NAME: '🇸🇦 Saudi Arabia' },
    SG: { NAME: '🇸🇬 Singapore' },
    KR: { NAME: '🇰🇷 South Korea' },
    LK: { NAME: '🇱🇰 Sri Lanka' },
    SY: { NAME: '🇸🇾 Syria' },
    TW: { NAME: '🇹🇼 Taiwan' },
    TJ: { NAME: '🇹🇯 Tajikistan' },
    TH: { NAME: '🇹🇭 Thailand' },
    TL: { NAME: '🇹🇱 Timor-Leste' },
    TR: { NAME: '🇹🇷 Türkiye' },
    TM: { NAME: '🇹🇲 Turkmenistan' },
    AE: { NAME: '🇦🇪 United Arab Emirates' },
    UZ: { NAME: '🇺🇿 Uzbekistan' },
    VN: { NAME: '🇻🇳 Vietnam' },
    YE: { NAME: '🇾🇪 Yemen' },

    // Africa
    DZ: { NAME: '🇩🇿 Algeria' },
    AO: { NAME: '🇦🇴 Angola' },
    BJ: { NAME: '🇧🇯 Benin' },
    BW: { NAME: '🇧🇼 Botswana' },
    BF: { NAME: '🇧🇫 Burkina Faso' },
    BI: { NAME: '🇧🇮 Burundi' },
    CV: { NAME: '🇨🇻 Cabo Verde' },
    CM: { NAME: '🇨🇲 Cameroon' },
    CF: { NAME: '🇨🇫 Central African Republic' },
    TD: { NAME: '🇹🇩 Chad' },
    KM: { NAME: '🇰🇲 Comoros' },
    CG: { NAME: '🇨🇬 Republic of the Congo' },
    CD: { NAME: '🇨🇩 Democratic Republic of the Congo' },
    CI: { NAME: '🇨🇮 Côte d’Ivoire' },
    DJ: { NAME: '🇩🇯 Djibouti' },
    EG: { NAME: '🇪🇬 Egypt' },
    GQ: { NAME: '🇬🇶 Equatorial Guinea' },
    ER: { NAME: '🇪🇷 Eritrea' },
    SZ: { NAME: '🇸🇿 Eswatini' },
    ET: { NAME: '🇪🇹 Ethiopia' },
    GA: { NAME: '🇬🇦 Gabon' },
    GM: { NAME: '🇬🇲 The Gambia' },
    GH: { NAME: '🇬🇭 Ghana' },
    GN: { NAME: '🇬🇳 Guinea' },
    GW: { NAME: '🇬🇼 Guinea-Bissau' },
    KE: { NAME: '🇰🇪 Kenya' },
    LS: { NAME: '🇱🇸 Lesotho' },
    LR: { NAME: '🇱🇷 Liberia' },
    LY: { NAME: '🇱🇾 Libya' },
    MG: { NAME: '🇲🇬 Madagascar' },
    MW: { NAME: '🇲🇼 Malawi' },
    ML: { NAME: '🇲🇱 Mali' },
    MR: { NAME: '🇲🇷 Mauritania' },
    MU: { NAME: '🇲🇺 Mauritius' },
    YT: { NAME: '🇾🇹 Mayotte' },
    MA: { NAME: '🇲🇦 Morocco' },
    MZ: { NAME: '🇲🇿 Mozambique' },
    NA: { NAME: '🇳🇦 Namibia' },
    NE: { NAME: '🇳🇪 Niger' },
    NG: { NAME: '🇳🇬 Nigeria' },
    RE: { NAME: '🇷🇪 Réunion' },
    RW: { NAME: '🇷🇼 Rwanda' },
    ST: { NAME: '🇸🇹 São Tomé and Príncipe' },
    SN: { NAME: '🇸🇳 Senegal' },
    SC: { NAME: '🇸🇨 Seychelles' },
    SL: { NAME: '🇸🇱 Sierra Leone' },
    SO: { NAME: '🇸🇴 Somalia' },
    ZA: { NAME: '🇿🇦 South Africa' },
    SS: { NAME: '🇸🇸 South Sudan' },
    SD: { NAME: '🇸🇩 Sudan' },
    TZ: { NAME: '🇹🇿 Tanzania' },
    TG: { NAME: '🇹🇬 Togo' },
    TN: { NAME: '🇹🇳 Tunisia' },
    UG: { NAME: '🇺🇬 Uganda' },
    EH: { NAME: '🇪🇭 Western Sahara' },
    ZM: { NAME: '🇿🇲 Zambia' },
    ZW: { NAME: '🇿🇼 Zimbabwe' },

    // Oceania, Australia and the Pacific
    AS: { NAME: '🇦🇸 American Samoa' },
    AU: { NAME: '🇦🇺 Australia' },
    CX: { NAME: '🇨🇽 Christmas Island' },
    CC: { NAME: '🇨🇨 Cocos (Keeling) Islands' },
    CK: { NAME: '🇨🇰 Cook Islands' },
    FJ: { NAME: '🇫🇯 Fiji' },
    PF: { NAME: '🇵🇫 French Polynesia' },
    GU: { NAME: '🇬🇺 Guam' },
    KI: { NAME: '🇰🇮 Kiribati' },
    MH: { NAME: '🇲🇭 Marshall Islands' },
    FM: { NAME: '🇫🇲 Micronesia' },
    NR: { NAME: '🇳🇷 Nauru' },
    NC: { NAME: '🇳🇨 New Caledonia' },
    NZ: { NAME: '🇳🇿 New Zealand' },
    NU: { NAME: '🇳🇺 Niue' },
    NF: { NAME: '🇳🇫 Norfolk Island' },
    MP: { NAME: '🇲🇵 Northern Mariana Islands' },
    PW: { NAME: '🇵🇼 Palau' },
    PG: { NAME: '🇵🇬 Papua New Guinea' },
    PN: { NAME: '🇵🇳 Pitcairn Islands' },
    WS: { NAME: '🇼🇸 Samoa' },
    SB: { NAME: '🇸🇧 Solomon Islands' },
    TK: { NAME: '🇹🇰 Tokelau' },
    TO: { NAME: '🇹🇴 Tonga' },
    TV: { NAME: '🇹🇻 Tuvalu' },
    UM: { NAME: '🇺🇲 U.S. Minor Outlying Islands' },
    VU: { NAME: '🇻🇺 Vanuatu' },
    WF: { NAME: '🇼🇫 Wallis and Futuna' },

    // Additional non-European territories
    IO: { NAME: '🇮🇴 British Indian Ocean Territory' },
    TF: { NAME: '🇹🇫 French Southern Territories' },
    HM: { NAME: '🇭🇲 Heard Island and McDonald Islands' },
    SH: { NAME: '🇸🇭 Saint Helena, Ascension and Tristan da Cunha' },

    // Retained from the original list
    NL: { NAME: '🇳🇱 The Netherlands' }
};

    // Do not show the popup again if it was dismissed this session.
    if (sessionStorage.getItem('storeRedirectDismissed') === '1') {
        return;
    }

    fetch(
        window.Shopify.routes.root +
        'browsing_context_suggestions.json?country[enabled]=true'
    )
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            return response.json();
        })
        .then(data => {
            const country = data.detected_values?.country?.handle;

            console.log('Detected country:', country);

            if (!country) {
                console.warn(
                    'No country detected in Shopify response.',
                    data
                );
                return;
            }

            if (!redirectCountries.includes(country.toUpperCase())) {
                console.log('Country is not in the redirect list.');
                return;
            }

            const countryInfo = countryNames[country.toUpperCase()];

            if (countryLabel && countryInfo) {
                countryLabel.textContent = countryInfo.NAME;
            }

            popup.hidden = false;

            console.log('Store redirect popup displayed.');
        })
        .catch(error => {
            console.error('Country detection failed:', error);
        });

    closeButton.addEventListener('click', function () {
        popup.hidden = true;
        sessionStorage.setItem('storeRedirectDismissed', '2');
    });
});
